export default function PickupIcon(props) {
    return (
        <svg width="19" height="19" viewBox="0 0 18 19" fill="transparent" xmlns="http://www.w3.org/2000/svg"  {...props}>
            <path d="M13 10V3.31429C13 2.03614 12.1941 1 11.2 1H4.8C3.80589 1 3 2.03614 3 3.31429V7.68571C3 8.96384 3.80589 10 4.8 10H13ZM13 10V12M9 10H2.025C0.906626 10 0 10.8059 0 11.8V16.2C0 17.1941 0.906626 18 2.025 18H9M9 10V18M9 10H15.975C17.0934 10 18 10.8059 18 11.8V16.2C18 17.1941 17.0934 18 15.975 18H9M5 10V12M9 1V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>


    );
}
